<template>
  <App>
    <AppBar>
      <AppTitle name="固定资产管理" />

    </AppBar>

    <AppClient style="background-color: #fff;">
       <!-- 资产类型快速筛选 -->
       <div class="asset-type-filter">
        <div class="type-tabs">
          <div
            class="type-tab"
            :class="{ active: !filters.type }"
            @click="selectAssetType('')"
          >
            全部 <span class="count">({{ assetTypeCounts.total || 0 }})</span>
          </div>
          <div
            v-for="type in assetTypes"
            :key="type.id"
            class="type-tab"
            :class="{ active: filters.type === type.name }"
            @click="selectAssetType(type.name)"
          >
            {{ type.name }} <span class="count">({{ assetTypeCounts[type.name] || 0 }})</span>
          </div>
        </div>
        <div class="type-config">
          <Button
            type="text"
            icon="ios-settings"
            @click="showTypeConfig"
            title="配置资产类型"
          >配置类型</Button>
        </div>
      </div>
      <div class="search-input-bar">
        <Input
          v-model="searchText"
          search
          placeholder="搜索资产名称或编号"
          style="width: 300px;"
          @on-search="handleSearch"
        />
        <Button
          type="primary"
          icon="md-add"
          @click="handleAdd"
          style="margin-left: 10px;"
        >新增资产</Button>
        <Button
          type="success"
          icon="ios-settings"
          @click="showTypeConfig"
          style="margin-left: 10px;"
        >类型配置</Button>
        <div style="flex: 1;"></div>
        <Button
          type="primary"
          icon="ios-download"
          @click="exportExcel"
        >导出数据</Button>
      </div>


      <!-- 筛选栏 -->
      <div class="filter-bar">
        <div class="filter-item">
          <span class="filter-label">状态</span>
          <div class="tag-filters">
            <Tag
              :color="filters.status === '' ? 'primary' : ''"
              checkable
              :checked="filters.status === ''"
              @click.native="setStatusFilter('')"
            >全部</Tag>
            <Tag
              :color="filters.status === '使用中' ? 'primary' : ''"
              checkable
              :checked="filters.status === '使用中'"
              @click.native="setStatusFilter('使用中')"
            >使用中</Tag>
            <Tag
              :color="filters.status === '闲置中' ? 'primary' : ''"
              checkable
              :checked="filters.status === '闲置中'"
              @click.native="setStatusFilter('闲置中')"
            >闲置中</Tag>
            <Tag
              :color="filters.status === '已报废' ? 'primary' : ''"
              checkable
              :checked="filters.status === '已报废'"
              @click.native="setStatusFilter('已报废')"
            >已报废</Tag>
          </div>
        </div>

        <div class="filter-item">
          <span class="filter-label">项目资产</span>
          <div class="tag-filters">
            <Tag
              :color="filters.in_project === null ? 'primary' : ''"
              checkable
              :checked="filters.in_project === null"
              @click.native="setProjectFilter(null)"
            >全部</Tag>
            <Tag
              :color="filters.in_project === true ? 'success' : ''"
              checkable
              :checked="filters.in_project === true"
              @click.native="setProjectFilter(true)"
            >是</Tag>
            <Tag
              :color="filters.in_project === false ? 'default' : ''"
              checkable
              :checked="filters.in_project === false"
              @click.native="setProjectFilter(false)"
            >否</Tag>
          </div>
        </div>

        <div class="filter-item">
          <span class="filter-label">归属部门</span>
          <Select v-model="filters.belong_top_dep_id" size="small" clearable placeholder="选择归属部门" style="width: 160px" @on-change="handleFilterChange">
            <Option v-for="dep in topDepartments" :key="dep.id" :value="dep.id">{{ dep.name }}</Option>
          </Select>
        </div>

        <div class="filter-item">
          <span class="filter-label">使用部门</span>
          <BaseDepSelectPro
                v-model="filters.dep_id"
                size="small"
                @on-change="handleFilterChange"
              />
        </div>

        <Button
          v-if="hasActiveFilters"
          type="primary"
          icon="ios-refresh"
          @click="resetFilters"
          size="small"
        >重置筛选</Button>
      </div>

      <div style="height:calc(100% - 150px);overflow:auto;padding:0 10px;">
        <BaseTable
          ref="table"
          :columns="columns"
          :data="assets"
          :count="pagination.total"
          :loading="loading"
          border
          paged
          :sum="sum"
          :page-size="pagination.pageSize"
          :page="pagination.current"
          @event="handleTableEvent"
        ></BaseTable>
      </div>
    </AppClient>

    <!-- 新增/编辑弹窗 -->
    <Modal v-model="showModal" :title="modalTitle" width="650" class="asset-modal">
      <div class="modal-header" slot="header">
        <Icon type="md-cube" size="24" color="#2d8cf0" />
        <span>{{ modalTitle }}</span>
      </div>

      <Form ref="form" :model="formData" :rules="rules" label-position="right" :label-width="100">
        <div class="form-section">
          <div class="form-row">
            <FormItem label="资产编号" prop="asset_id" class="form-item">
              <Input v-model="formData.asset_id" placeholder="请输入资产编号" />
            </FormItem>
            <FormItem label="资产名称" prop="name" class="form-item">
              <Input v-model="formData.name" placeholder="请输入资产名称" />
            </FormItem>
          </div>

          <div class="form-row">
            <FormItem label="资产类型" prop="type" class="form-item">
              <Select v-model="formData.type" placeholder="请选择资产类型">
                <Option v-for="type in assetTypes" :key="type.id" :value="type.name">{{ type.name }}</Option>
              </Select>
            </FormItem>
            <FormItem label="购买金额" prop="purchase_amount" class="form-item">
              <BaseAmountInput
                :editable="true"
                v-model="formData.purchase_amount"
                :precision="2"
                :step="0.01"
                style="width: 100%"
                placeholder="请输入购买金额"
              />
            </FormItem>
          </div>

          <div class="form-row">
            <FormItem label="购买时间" prop="purchase_time" class="form-item">
              <DatePicker
                v-model="formData.purchase_time"
                type="datetime"
                placeholder="请选择购买时间"
                style="width: 100%"
              />
            </FormItem>
          </div>

          <FormItem label="归属部门" prop="belong_top_dep_id">
            <Select
              v-model="formData.belong_top_dep_id"
              placeholder="请选择归属部门"
              style="width: 100%"
            >
              <Option v-for="dep in topDepartments" :key="dep.id" :value="dep.id">{{ dep.name }}</Option>
            </Select>
          </FormItem>

          <div class="form-row">
            <FormItem label="使用部门" prop="dep_id" class="form-item">
              <BaseDepSelectPro
                v-model="formData.dep_id"
                :top-id.sync="formData.top_dep_id"
              />
            </FormItem>
            <FormItem label="使用人" prop="user_id" class="form-item">
              <BaseUserSelectGrouped v-model="formData.user_id" :option="{ users }" />
            </FormItem>
          </div>

          <FormItem label="划入项目" prop="in_project">
            <i-switch v-model="formData.in_project" size="large">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
            <span style="margin-left: 10px; color: #808695;">选择"是"表示该资产已划入项目</span>
          </FormItem>

          <FormItem label="资产描述" prop="description">
            <Input type="textarea" :rows="4" v-model="formData.description" placeholder="请输入资产描述" />
          </FormItem>

          <FormItem label="备注" prop="remark">
            <Input type="textarea" v-model="formData.remark" placeholder="请输入备注" />
          </FormItem>
        </div>
      </Form>

      <div slot="footer" class="modal-footer">
        <Button @click="showModal = false" class="cancel-btn">取消</Button>
        <Button type="primary" @click="handleSubmit" :loading="submitting">确定</Button>
      </div>
    </Modal>

    <!-- 资产详情抽屉 -->
    <Drawer
      v-model="showDetailDrawer"
      :title="detailData.name"
      width="650"
      :closable="true"
      class="asset-detail-drawer"
    >
      <Spin v-if="detailLoading" size="large" fix></Spin>
      <div class="detail-content" v-else>
        <div class="detail-header flex-wrap flex-between" style="margin-bottom:10px;">
          <div class="asset-id-box">
            <Icon type="md-barcode" size="18" />
            <span class="asset-id" style="margin-left:10px;">{{ detailData.asset_id }}</span>
          </div>
          <Tag :color="getStatusColor(detailData.status)" class="status-tag">{{ detailData.status || '使用中' }}</Tag>
        </div>

        <Card class="detail-card">
          <p slot="title"><Icon type="md-information-circle" /> 基本信息</p>
          <div class="detail-grid">
            <div class="detail-item">
              <strong><Icon type="md-pricetag" /> 资产类型</strong>
              <span>{{ detailData.type }}</span>
            </div>
            <div class="detail-item">
              <strong><Icon type="logo-yen" /> 购买金额</strong>
              <span>{{ formatMoney(detailData.purchase_amount) }}</span>
            </div>
            <div class="detail-item">
              <strong><Icon type="md-calendar" /> 购买时间</strong>
              <span>{{ moment(detailData.purchase_time).format('YYYY-MM-DD HH:mm:ss') }}</span>
            </div>
            <div class="detail-item">
              <strong><Icon type="ios-list-box" /> 项目资产</strong>
              <span>
                <Tag v-if="detailData.in_project" color="success" type="dot">是</Tag>
                <Tag v-else color="default" type="dot">否</Tag>
              </span>
            </div>
            <div class="detail-item">
              <strong><BaseIcon icon="organization" /> 归属部门</strong>
              <span>{{ getDepNameById(detailData.belong_top_dep_id) || '-' }}</span>
            </div>
            <div class="detail-item">
              <strong><BaseIcon icon="organization" /> 所属事业部</strong>
              <span>{{ getDepNameById(detailData.top_dep_id) || '-' }}</span>
            </div>
            <div class="detail-item">
              <strong><BaseIcon icon="organization" /> 使用部门</strong>
              <span>{{ getDepNameById(detailData.dep_id) || '-' }}</span>
            </div>
            <div class="detail-item">
              <strong><Icon type="md-person" /> 使用人</strong>
              <span>{{ users.find(u => u.id === detailData.user_id) ? users.find(u => u.id === detailData.user_id).name : '-' }}</span>
            </div>
          </div>
        </Card>

        <Card class="detail-card">
          <p slot="title"><Icon type="md-create" /> 描述与备注</p>
          <div class="desc-section">
            <h4><Icon type="md-document" /> 资产描述</h4>
            <div class="desc-content" style="white-space: pre-wrap;">{{ detailData.description || '暂无描述' }}</div>
          </div>
          <div class="desc-section">
            <h4><Icon type="md-list" /> 备注信息</h4>
            <div class="desc-content">{{ detailData.remark || '暂无备注' }}</div>
          </div>
        </Card>

        <Card class="detail-card">
          <p slot="title"><Icon type="md-time" /> 处置历史记录</p>
          <div v-if="!detailData.records || detailData.records.length === 0" class="no-records">
            <Icon type="md-alert" size="20" />
            <span>暂无处置记录</span>
          </div>
          <div v-else class="records-list">
            <Timeline>
              <TimelineItem
                v-for="(record, index) in detailData.records.slice().sort((a, b) => new Date(b.disposal_time) - new Date(a.disposal_time))"
                :key="index"
                :color="getTimelineColor(record.disposal_type)"
              >
                <p class="record-time">{{ moment(record.disposal_time).format('YYYY-MM-DD HH:mm:ss') }}</p>
                <div class="record-content">
                  <div class="record-main-info">
                    <Tag :color="getTypeTagColor(record.disposal_type)">{{ record.disposal_type }}</Tag>
                    <span class="record-info-item">涉及部门: {{ getDepNameById(record.dep_id) || '-' }}</span>
                    <span class="record-info-item">{{ getOperatorLabel(record.disposal_type) }}: {{ users.find(u => u.id === record.operator_id) ? users.find(u => u.id === record.operator_id).name : '-' }}</span>
                    <span class="record-info-item">办理人: {{ users.find(u => u.id === record.created_by) ? users.find(u => u.id === record.created_by).name : '-' }}</span>
                  </div>
                  <div class="record-extra-info" v-if="record.remark || record.disposal_proof">
                    <p class="record-remark" v-if="record.remark">备注: {{ record.remark }}</p>
                    <p v-if="record.disposal_proof"><a :href="record.disposal_proof" target="_blank">查看附件</a></p>
                  </div>
                </div>
              </TimelineItem>
            </Timeline>
          </div>
        </Card>
      </div>
    </Drawer>

    <!-- 资产处置弹窗 -->
    <Modal v-model="showDisposalModal" :title="getDisposalTitle()" width="600" class="disposal-modal">
      <div class="modal-header" slot="header">
        <Icon type="md-swap" size="24" color="#ff9900" />
        <span>{{ getDisposalTitle() }}</span>
      </div>

      <Form ref="disposalForm" :model="disposalFormData" :rules="disposalRules" label-position="right" :label-width="100">
        <div class="form-section">
          <FormItem label="处置方式" prop="disposal_type">
            <RadioGroup v-model="disposalFormData.disposal_type">
              <Radio v-for="option in getDisposalTypeOptions()" :key="option.value" :label="option.value">{{ option.label }}</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="处置时间" prop="disposal_time">
            <DatePicker
              v-model="disposalFormData.disposal_time"
              type="datetime"
              placeholder="请选择处置时间"
              style="width: 100%"
            />
          </FormItem>
          <FormItem label="涉及人" prop="operator_id">
            <BaseUserSelectGrouped v-model="disposalFormData.operator_id" :option="{ users }" />
          </FormItem>
          <FormItem label="涉及部门" prop="dep_id">
            <Select
              v-model="disposalFormData.dep_id"
              placeholder="请选择涉及部门"
              style="width: 100%"
            >
              <Option v-for="dep in deps" :key="dep.id" :value="dep.id">{{ dep.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="处置备注" prop="remark">
            <Input type="textarea" :rows="3" v-model="disposalFormData.remark" placeholder="请输入处置备注" />
          </FormItem>
          <FormItem label="处置凭证" prop="disposal_proof">
            <BaseFileUpload v-model="disposalFormData.disposal_proof" :limit="1" />
          </FormItem>
        </div>
      </Form>

      <div slot="footer" class="modal-footer">
        <div class="btn-group">
          <Button type="primary" @click="handleDisposalSubmit" :loading="disposalSubmitting">确定</Button>
          <Button @click="showDisposalModal = false" class="cancel-btn">取消</Button>
        </div>

        <div class="records-history">
          <h3>处置历史记录</h3>
          <Spin v-if="detailLoading" size="large"></Spin>
          <div v-else-if="!currentAsset || !currentAsset.records || currentAsset.records.length === 0" class="no-records">
            暂无处置记录
          </div>
          <div v-else class="records-list">
            <Timeline>
              <TimelineItem
                v-for="(record, index) in currentAsset.records.slice().sort((a, b) => new Date(b.disposal_time) - new Date(a.disposal_time))"
                :key="index"
                :color="getTimelineColor(record.disposal_type)"
              >
                <p class="record-time">{{ moment(record.disposal_time).format('YYYY-MM-DD HH:mm:ss') }}</p>
                <div class="record-content">
                  <div class="record-main-info">
                    <Tag :color="getTypeTagColor(record.disposal_type)">{{ record.disposal_type }}</Tag>
                    <span class="record-info-item">涉及部门: {{ getDepNameById(record.dep_id) || '-' }}</span>
                    <span class="record-info-item">{{ getOperatorLabel(record.disposal_type) }}: {{ users.find(u => u.id === record.operator_id) ? users.find(u => u.id === record.operator_id).name : '-' }}</span>
                    <span class="record-info-item">办理人: {{ users.find(u => u.id === record.created_by) ? users.find(u => u.id === record.created_by).name : '-' }}</span>
                  </div>
                  <div class="record-extra-info" v-if="record.remark || record.disposal_proof">
                    <p class="record-remark" v-if="record.remark">备注: {{ record.remark }}</p>
                    <p v-if="record.disposal_proof"><a :href="record.disposal_proof" target="_blank">查看附件</a></p>
                  </div>
                </div>
              </TimelineItem>
            </Timeline>
          </div>
        </div>
      </div>
    </Modal>

    <!-- 资产类型配置模态框 -->
    <Modal v-model="showTypeConfigModal" title="资产类型配置" width="700" class="type-config-modal">
      <div class="modal-header" slot="header">
        <Icon type="ios-options" size="24" color="#2d8cf0" />
        <span>管理资产类型</span>
      </div>

      <div class="type-config-content">
        <div class="type-form">
          <Form :model="typeFormData" inline :label-width="80">
            <FormItem label="类型名称">
              <Input v-model="typeFormData.name" placeholder="请输入类型名称" style="width: 200px" />
            </FormItem>
            <FormItem>
              <Button type="primary" @click="handleAddType" :loading="typeConfigLoading" :disabled="!typeFormData.name">添加类型</Button>
            </FormItem>
          </Form>
        </div>

        <div class="type-list">
          <Table :loading="typeConfigLoading" :columns="typeColumns" :data="assetTypes" border>
            <template slot-scope="{ row }" slot="count">
              {{ assetTypeCounts[row.name] || 0 }}
            </template>
            <template slot-scope="{ row }" slot="action">
              <Button
                type="error"
                size="small"
                @click="handleDeleteType(row)"
                :disabled="assetTypeCounts[row.name] > 0"
              >删除</Button>
            </template>
          </Table>
        </div>
      </div>

      <div slot="footer" class="modal-footer">
        <Button @click="showTypeConfigModal = false">关闭</Button>
      </div>
    </Modal>
  </App>
</template>

<script>

import * as XLSX from 'xlsx';
import moment from 'moment';
import App from '@/components/app/app';
import AppBar from '@/components/app/bar';
import AppClient from '@/components/app/client';
import AppTitle from '@/components/app/title';

export default {
  name: 'FixedAssetsPage',
  components: {
    App,
    AppBar,
    AppClient,
    AppTitle,
  },
  data() {
    return {
      loading: false,
      submitting: false,
      showModal: false,
      showDetailDrawer: false,
      showDisposalModal: false,
      disposalSubmitting: false,
      detailLoading: false,
      currentAsset: null,
      detailData: {},
      lastLoadedAssetId: null,
      disposalFormData: {
        disposal_type: '',
        disposal_time: new Date(),
        operator_id: null,
        dep_id: null,
        remark: '',
        disposal_proof: '',
      },
      modalTitle: '新增资产',
      searchText: '',
      filters: {
        status: '',
        dep_id: null,
        top_dep_id: null,
        belong_top_dep_id: null,
        type: '',
        in_project: null,
      },
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      order: {key: 'created_at', type: 'desc'},
      assets: [],
      sum: {},
      formData: {
        asset_id: '',
        name: '',
        type: '',
        description: '',
        purchase_time: null,
        purchase_amount: 0,
        dep_id: null,
        top_dep_id: null,
        belong_top_dep_id: null,
        user_id: null,
        in_project: false,
        remark: '',
      },
      assetTypes: [],
      assetTypeCounts: {},
      showTypeConfigModal: false,
      typeConfigLoading: false,
      typeFormData: {
        name: '',
      },
      typeColumns: [
        {title: '序号', type: 'index', width: 80},
        {title: '类型名称', key: 'name'},
        {title: '资产数量', slot: 'count', width: 100},
        {title: '操作', slot: 'action', width: 100, align: 'center'},
      ],
      rules: {
        asset_id: [
          {required: true, message: '请输入资产编号', trigger: 'blur'},
        ],
        name: [
          {required: true, message: '请输入资产名称', trigger: 'blur'},
        ],
        type: [
          {required: true, message: '请输入资产类型', trigger: 'blur'},
        ],


      },
      disposalRules: {
        disposal_type: [
          {required: true, message: '请选择处置方式', trigger: 'change'},
        ],
        disposal_time: [],
        operator_id: [],
        dep_id: [
          {required: true, message: '请选择涉及部门', trigger: 'change'},
        ],
      },
      columns: [
        {
          type: 'index',
          title: '序号',
          width: 80,
        },
        {
          type: 'text',
          title: '资产编号',
          key: 'asset_id',
          width: 170,
        },
        {
          type: 'text',
          title: '资产类型',
          key: 'type',
          width: 120,
          render: (h, params) => {
            return h('span', {
              style: {
                display: 'inline-block',
                padding: '0px 8px',
                borderRadius: '4px',
                backgroundColor: this.getTypeColor(params.row.type),
                color: '#fff',
              },
            }, params.row.type);
          },
        },
        {
          type: 'text',
          title: '资产名称',
          key: 'name',
          minWidth: 300,
          render: (h, params) => {
            return h('div', {
              style: {
                display: 'flex',
                alignItems: 'center',

                cursor: 'pointer',
                color: '#2d8cf0',
                padding: '0 10px',
              },
              on: {
                click: () => {
                  this.showDetail(params.row);
                },
              },
            }, [
              h('Icon', {
                props: {
                  type: 'md-cube',
                  size: 16,
                },
                style: {
                  marginRight: '5px',
                },
              }),
              h('span', {
                style: {
                  textDecoration: 'underline',
                  textAlign: 'left',
                },
              }, params.row.name),
            ]);
          },
        },
        {
          type: 'text',
          title: '资产状态',
          key: 'status',
          width: 100,
          render: (h, params) => {
            return h('span', {
              style: {
                display: 'inline-block',
                padding: '0px 8px',
                borderRadius: '4px',
                backgroundColor: this.getStatusColor(params.row.status),
                color: '#fff',
              },
            }, params.row.status || '使用中');
          },
        },
        {
          type: 'number',
          title: '购买金额',
          key: 'purchase_amount',
          width: 120,
          option: {
            sumable: true,
            formatter: (val) => this.formatMoney(val),
          },
        },
        {
          type: 'text',
          title: '项目资产',
          key: 'in_project',
          width: 90,
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: params.row.in_project ? 'success' : 'default',
                type: 'dot',
              },
            }, params.row.in_project ? '是' : '否');
          },
        },
        {
          type: 'text',
          title: '归属部门',
          key: 'belong_top_dep_id',
          width: 140,
          render: (h, {row}) => {
            return h('span', this.getDepNameById(row.belong_top_dep_id) || '-');
          },
        },
        {
          type: 'text',
          title: '使用部门',
          key: 'dep_id',
          width: 140,
          render: (h, {row}) => {
            return h('span', this.getDepNameById(row.dep_id) || '-');
          },
        },
        {
          type: 'text',
          title: '使用人',
          key: 'user_id',
          width: 120,
          render: (h, {row}) => {
            return h('span', this.users.find((u) => u.id === row.user_id)?.name || '-');
          },
        },
        {
          type: 'text',
          title: '备注',
          key: 'remark',
          width: 150,
          render: (h, params) => {
            if (!params.row.remark && !params.row.in_project) {
              return h('span', {style: {color: '#ccc'}}, '无');
            }

            return h('div', [
              params.row.in_project ? h('Tag', {
                props: {
                  color: 'success',
                  type: 'dot',
                },
                style: {
                  marginRight: '5px',
                },
              }, '项目资产') : null,
              params.row.remark ? h('span', params.row.remark) : null,
            ]);
          },
        },
        {
          type: 'time',
          title: '创建时间',
          key: 'created_at',
          width: 120,
        },

        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          width: 250,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.handleDisposal(params.row);
                  },
                },
              }, '操作'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                },
                style: {
                  marginLeft: '5px',
                },
                on: {
                  click: () => {
                    this.handleEdit(params.row);
                  },
                },
              }, '编辑'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                },
                style: {
                  marginLeft: '5px',
                },
                on: {
                  click: () => {
                    this.handleDelete(params.row);
                  },
                },
              }, '删除'),
            ]);
          },
        },
      ],
    };
  },
  computed: {
    deps() {
      return this.$store.getters['session/deps'];
    },
    users() {
      return this.$store.getters['session/users'];
    },
    topDepartments() {
      return this.deps.filter((dep) => dep.top === 1 && dep.ignore !== 1);
    },
    depTreeData() {
      return this.buildDepTree(this.deps);
    },
    filteredAssets() {
      let result = this.assets;

      // Apply asset type filter
      if (this.filters.type) {
        result = result.filter((item) => item.type === this.filters.type);
      }

      // Apply top_dep_id filter
      if (this.filters.top_dep_id) {
        result = result.filter((item) => item.top_dep_id === this.filters.top_dep_id);
      }

      // Apply belong_top_dep_id filter
      if (this.filters.belong_top_dep_id) {
        result = result.filter((item) => item.belong_top_dep_id === this.filters.belong_top_dep_id);
      }

      // Apply in_project filter
      if (this.filters.in_project !== null) {
        result = result.filter((item) => item.in_project === this.filters.in_project);
      }

      return result;
    },
    hasActiveFilters() {
      return !!this.filters.status || !!this.filters.dep_id || !!this.filters.top_dep_id ||
             !!this.filters.belong_top_dep_id || !!this.filters.type || !!this.filters.in_project;
    },
  },
  mounted() {
    this.$api.afterLogin(() => {
      this.$store.dispatch('session/getUsers');
      this.$store.dispatch('session/getDeps');
      this.fetchAssetTypes();
      this.fetchAssetTypeCounts();
      this.getData(true);
    });
  },
  methods: {
    formatMoney(val) {
      return val ? `¥${val.toFixed(2)}` : '-';
    },

    handleSearch() {
      this.pagination.current = 1;
      this.getData();
    },

    handleFilterChange() {
      this.pagination.current = 1;
      this.getData();
    },

    handleTableEvent(e) {
      const {type, data} = e;
      switch (type) {
        case 'page-change':
          this.pagination.current = data;
          this.getData();
          break;
        case 'page-size-change':
          this.pagination.pageSize = data;
          this.pagination.current = 1;
          this.getData();
          break;
        case 'sort':
          this.order = data;
          this.pagination.current = 1;
          this.getData();
          break;
      }
    },

    async getData() {
      this.loading = true;
      try {
        const response = await this.$api.get('/oa/fixed_assets', {
          params: {
            q: 'page',
            page: this.pagination.current,
            pagesize: this.pagination.pageSize,
            search: this.searchText,
            status: this.filters.status || undefined,
            dep_id: this.filters.dep_id || undefined,
            top_dep_id: this.filters.top_dep_id || undefined,
            belong_top_dep_id: this.filters.belong_top_dep_id || undefined,
            type: this.filters.type || undefined,
            in_project: this.filters.in_project?1:undefined,
            order: this.order.key,
            desc: this.order.type == 'desc',
          },
        });

        this.assets = response.data.data.list || [];
        this.pagination.total = response.data.data.count || 0;

        this.$nextTick(() => {
          this.loading = false;
        });
      } catch (error) {
        this.loading = false;
        this.$Message.error('获取资产列表失败');
        console.error(error);
      }
    },

    handleAdd() {
      this.modalTitle = '新增资产';
      this.formData = {
        asset_id: '',
        name: '',
        type: '',
        description: '',
        purchase_time: null,
        purchase_amount: 0,
        dep_id: null,
        top_dep_id: null,
        belong_top_dep_id: null,
        user_id: null,
        in_project: false,
        remark: '',
      };
      this.showModal = true;
    },

    handleEdit(row) {
      this.modalTitle = '编辑资产';
      this.formData = {...row};
      this.showModal = true;
    },

    handleDelete(row) {
      this.$Modal.confirm({
        title: '确认删除',
        content: `确定要删除资产"${row.name}"吗？`,
        onOk: async () => {
          try {
            await this.$api.delete(`/oa/fixed_assets/${row.id}`);
            this.$Message.success('删除成功');
            this.getData();
          } catch (error) {
            this.$Message.error('删除失败');
          }
        },
      });
    },

    async handleSubmit() {
      try {
        await this.$refs.form.validate();
        this.submitting = true;

        const method = this.formData.id ? 'put' : 'post';
        const url = this.formData.id ? `/oa/fixed_assets/${this.formData.id}` : '/oa/fixed_assets';

        await this.$api[method](url, this.formData);
        this.$Message.success(this.formData.id ? '更新成功' : '添加成功');
        this.showModal = false;
        this.getData();
      } catch (error) {
        if (error.message) {
          this.$Message.error(error.message);
        }
      } finally {
        this.submitting = false;
      }
    },

    exportExcel() {
      const data = this.assets.map((item) => ({
        '资产编号': item.asset_id,
        '资产名称': item.name,
        '资产类型': item.type,
        '资产状态': item.status || '使用中',
        '项目资产': item.in_project ? '是' : '否',
        '资产描述': item.description,
        '购买金额': item.purchase_amount,
        '归属部门': this.getDepNameById(item.belong_top_dep_id) || '-',
        '所属事业部': this.getDepNameById(item.top_dep_id) || '-',
        '使用部门': this.getDepNameById(item.dep_id) || '-',
        '使用人': this.users.find((u) => u.id === item.user_id)?.name || '-',
        '备注': item.remark,
        '创建时间': moment(item.created).format('YYYY-MM-DD HH:mm:ss'),
      }));

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '固定资产列表');

      const wbout = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
      const blob = new Blob([wbout], {type: 'application/octet-stream'});

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `固定资产列表_${moment().format('YYYYMMDD')}.xlsx`;
      link.click();

      setTimeout(() => {
        URL.revokeObjectURL(link.href);
        link.remove();
      }, 500);
    },

    showDetail(row) {
      // 先使用基础对象，确保records属性存在
      this.detailData = {...row, records: []};
      this.showDetailDrawer = true;
      this.fetchAssetDetails(row.id);
    },
    buildDepTree(deps) {
      // 先构建一个映射表
      const depMap = new Map();
      deps.forEach((dep) => {
        depMap.set(dep.id, {
          title: dep.name,
          value: dep.id,
          expand: true, // 默认展开所有节点
          selected: false, // 不要在这里设置selected，让Tree组件自己控制
          children: [],
        });
      });

      // 构建树形结构
      const tree = [];
      deps.forEach((dep) => {
        const node = depMap.get(dep.id);
        if (dep.parent_id && depMap.has(dep.parent_id)) {
          // 如果有父节点，将当前节点添加到父节点的children中
          depMap.get(dep.parent_id).children.push(node);
        } else {
          // 如果没有父节点或父节点不存在，则作为根节点
          tree.push(node);
        }
      });

      return tree;
    },

    getDepNameById(depId) {
      if (!depId) return '';
      const findDep = (tree) => {
        for (const node of tree) {
          if (node.value === depId) return node.title;
          if (node.children && node.children.length) {
            const found = findDep(node.children);
            if (found) return found;
          }
        }
        return null;
      };
      return findDep(this.depTreeData);
    },

    handleModalDepSelect(selectedNodes) {
      if (selectedNodes.length > 0) {
        this.formData.dep_id = selectedNodes[0].value;
        console.log(selectedNodes, this.formData);
      }
    },

    handleModalDepChange(value) {
      // 不需要这个方法了，因为我们在handleModalDepSelect中已经处理了值的同步
    },

    getTypeColor(type) {
      const colors = {
        '台式电脑': '#2d8cf0',
        '笔记本电脑': '#19be6b',
        '屏幕': '#ff9900',
        '打印机': '#ed4014',
      };
      return colors[type] || '#808695';
    },

    getStatusColor(status) {
      const colors = {
        '使用中': '#2d8cf0',
        '闲置中': '#ff9900',
        '已报废': '#ed4014',
      };
      return colors[status] || '#808695';
    },

    getDisposalActions(status) {
      // 根据资产状态返回可进行的操作
      switch (status || '使用中') {
        case '闲置中':
          return [
            {action: 'borrow', label: '借出'},
            {action: 'scrap', label: '报废'},
          ];
        case '使用中':
          return [
            {action: 'return', label: '归还'},
          ];
        case '已报废':
          return [
            {action: 'undoScrap', label: '撤销报废'},
          ];
        default:
          return [];
      }
    },

    getDisposalTypeOptions() {
      if (!this.currentAsset) return [];

      const status = this.currentAsset.status || '使用中';

      switch (status) {
        case '闲置中':
          return [
            {value: '领用', label: '领用'},
            {value: '报废', label: '报废'},
          ];
        case '使用中':
          return [
            {value: '归还', label: '归还'},
          ];
        case '已报废':
          return [
            {value: '撤销报废', label: '撤销报废'},
          ];
        default:
          return [];
      }
    },

    getDisposalTitle() {
      if (!this.currentAsset) return '资产处置';
      return `${this.currentAsset.name} - 资产处置`;
    },

    handleDisposal(row) {
      // 先初始化currentAsset为不含records的基础对象
      this.currentAsset = {...row, records: []};

      // 初始化处置表单数据
      this.disposalFormData = {
        disposal_type: '',
        disposal_time: new Date(),
        operator_id: row.user_id,
        dep_id: row.dep_id,
        remark: '',
        disposal_proof: '',
      };

      // 根据资产状态自动设置默认处置类型
      const status = row.status || '使用中';
      switch (status) {
        case '闲置中':
          this.disposalFormData.disposal_type = '领用';
          break;
        case '使用中':
          this.disposalFormData.disposal_type = '归还';
          break;
        case '已报废':
          this.disposalFormData.disposal_type = '撤销报废';
          break;
      }

      // 显示弹窗，然后异步加载完整数据
      this.showDisposalModal = true;
      this.fetchAssetDetails(row.id);
    },

    async fetchAssetDetails(id) {
      // 强制清除缓存的ID，确保每次都重新加载
      this.lastLoadedAssetId = null;
      this.detailLoading = true;

      try {
        const res = await this.$api.get(`/oa/fixed_assets/${id}`, {
          params: {
            related: 'records',
          },
        });

        const assetData = res.data.data;

        // 确保records字段存在
        if (!assetData.records) {
          assetData.records = [];
        }

        // 更新资产详情
        if (this.showDetailDrawer) {
          this.detailData = assetData;
        }

        // 更新当前资产
        if (this.showDisposalModal) {
          this.currentAsset = assetData;
        }

        // 记录最后加载的资产ID
        this.lastLoadedAssetId = id;
      } catch (error) {
        this.$Message.error('获取资产详情失败');
        // 确保即使失败也有基本数据
        if (this.showDetailDrawer && !this.detailData.records) {
          this.detailData.records = [];
        }
        if (this.showDisposalModal && !this.currentAsset.records) {
          this.currentAsset.records = [];
        }
      } finally {
        this.detailLoading = false;
      }
    },

    async handleDisposalSubmit() {
      try {
        await this.$refs.disposalForm.validate();
        this.disposalSubmitting = true;

        // 确定资产新状态
        let newStatus = this.currentAsset.status;
        switch (this.disposalFormData.disposal_type) {
          case '领用':
            newStatus = '使用中';
            break;
          case '归还':
            newStatus = '闲置中';
            break;
          case '报废':
            newStatus = '已报废';
            break;
          case '撤销报废':
            newStatus = '闲置中';
            break;
        }

        // 调用API提交处置记录
        await this.$api.post(`/oa/fixed_assets/${this.currentAsset.id}/records`, this.disposalFormData);

        // 更新资产状态
        await this.$api.patch(`/oa/fixed_assets/${this.currentAsset.id}`, {status: newStatus});

        // 更新本地数据
        const index = this.assets.findIndex((item) => item.id === this.currentAsset.id);
        if (index !== -1) {
          this.assets[index].status = newStatus;
        }

        this.$Message.success('处置成功');
        this.showDisposalModal = false;
      } catch (error) {
        if (error.message) {
          this.$Message.error(error.message);
        } else {
          this.$Message.error('处置失败');
        }
      } finally {
        this.disposalSubmitting = false;
      }
    },
    getTimelineColor(disposalType) {
      const colors = {
        '领用': 'blue',
        '归还': 'green',
        '报废': 'red',
        '撤销报废': 'yellow',
      };
      return colors[disposalType] || 'blue';
    },

    getTypeTagColor(disposalType) {
      const colors = {
        '领用': 'primary',
        '归还': 'success',
        '报废': 'error',
        '撤销报废': 'warning',
      };
      return colors[disposalType] || 'default';
    },

    getOperatorLabel(disposalType) {
      switch (disposalType) {
        case '领用':
          return '领用人';
        case '归还':
          return '交还人';
        case '报废':
        case '撤销报废':
          return '处理人';
        default:
          return '涉及人';
      }
    },
    selectAssetType(type) {
      this.filters.type = type;
      this.handleFilterChange();
    },
    resetFilters() {
      this.filters = {
        status: '',
        dep_id: null,
        top_dep_id: null,
        belong_top_dep_id: null,
        type: '',
        in_project: null,
      };
      this.handleFilterChange();
    },
    async fetchAssetTypes() {
      try {
        const response = await this.$api.get('/oa/fixed-asset-types');
        this.assetTypes = response.data.data || [];
      } catch (error) {
        this.$Message.error('获取资产类型失败');
        console.error(error);
      }
    },
    async fetchAssetTypeCounts() {
      try {
        const response = await this.$api.get('/oa/fixed_assets', {
          params: {
            q: 'count',
            count_by: 'type',
          },
        });
        this.assetTypeCounts = response.data.data || {};
      } catch (error) {
        this.$Message.error('获取资产类型统计失败');
        console.error(error);
      }
    },
    showTypeConfig() {
      this.showTypeConfigModal = true;
    },
    async handleAddType() {
      if (!this.typeFormData.name) {
        this.$Message.warning('请输入类型名称');
        return;
      }

      this.typeConfigLoading = true;
      try {
        await this.$api.post('/oa/fixed-asset-types', {name: this.typeFormData.name});
        this.$Message.success('添加类型成功');
        this.typeFormData.name = ''; // Reset the input
        await this.fetchAssetTypes();
        await this.fetchAssetTypeCounts();
      } catch (error) {
        this.$Message.error(error.message || '添加类型失败');
        console.error(error);
      } finally {
        this.typeConfigLoading = false;
      }
    },
    async handleDeleteType(row) {
      if (this.assetTypeCounts[row.name] > 0) {
        this.$Message.warning('该类型下有资产，无法删除');
        return;
      }

      this.$Modal.confirm({
        title: '确认删除',
        content: `确定要删除资产类型"${row.name}"吗？`,
        onOk: async () => {
          this.typeConfigLoading = true;
          try {
            await this.$api.delete(`/oa/fixed-asset-types/${row.id}`);
            this.$Message.success('删除类型成功');
            await this.fetchAssetTypes();
            await this.fetchAssetTypeCounts();
          } catch (error) {
            this.$Message.error(error.message || '删除类型失败');
            console.error(error);
          } finally {
            this.typeConfigLoading = false;
          }
        },
      });
    },
    setStatusFilter(status) {
      this.filters.status = status;
      this.handleFilterChange();
    },
    setProjectFilter(project) {
      this.filters.in_project = project;
      this.handleFilterChange();
    },
  },
};
</script>

<style lang="less" scoped>
.asset-type-filter {
  display: flex;
  padding: 10px 15px;
  background: #f8f8f9;
  justify-content: space-between;

  .type-tabs {
    display: flex;
    flex-wrap: wrap;
    flex: 1;

    .type-tab {
      cursor: pointer;
      padding: 6px 15px;
      border-radius: 16px;
      margin-right: 10px;
      font-size: 14px;
      background-color: #f0f0f0;
      color: #515a6e;
      transition: all 0.2s ease;

      .count {
        font-size: 12px;
        color: #808695;
      }

      &:hover {
        background-color: #e8e8e8;
      }

      &.active {
        background-color: #2d8cf0;
        color: #fff;

        .count {
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }
  }

  .type-config {
    display: flex;
    align-items: center;
  }
}

/* 筛选栏样式 */
.filter-bar {
  height:30px;
  padding: 0 15px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;
}

.filter-item {
  display: flex;
  align-items: center;
  margin-right: 24px;
  margin-bottom: 10px;
}

.filter-label {
  color: #909399;
  margin-right: 10px;
  font-size: 13px;
  font-weight: 500;
  display: inline-block;
  white-space: nowrap;
}

.tag-filters {
  display: flex;
  flex-wrap: wrap;

  .ivu-tag {
    margin-right: 6px;
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.2s ease-in-out;

    &:hover {
      opacity: 0.8;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}

.asset-modal, .disposal-modal {
  margin-top: -30px;
}

::v-deep .ivu-modal-content {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

::v-deep .ivu-modal-header {
  background: #f8f9fa;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

::v-deep .ivu-modal-body {
  padding: 0;
}

.modal-header {
  display: flex;
  align-items: center;
}

.modal-header span {
  font-size: 16px;
  font-weight: 500;
  margin-left: 10px;
  color: #2d8cf0;
}

.modal-footer {
  border-top: 1px solid #f0f0f0;
  padding: 12px 18px;
  text-align: right;
  background: #f8f9fa;
}

.form-section {
  padding: 20px;
}

.form-row {
  display: flex;
  margin: 0 -8px;
  margin-bottom: 10px;
}

.form-item {
  padding: 0 8px;
  flex: 1;
}

.cancel-btn {
  margin-right: 8px;
}

.btn-group {
  display: flex;
  justify-content: flex-end;
}

.records-history {
  border-top: 1px solid #e8e8e8;
  padding: 20px;
  margin-top: 20px;

  h3 {
    margin-bottom: 15px;
    font-size: 16px;
    color: #17233d;
  }

  .no-records {
    text-align: center;
    color: #808695;
    padding: 20px 0;
  }

  .records-list {
    max-height: 350px;
    overflow-y: auto;
    padding: 10px;

    .record-time {
      font-weight: bold;
      color: #2d8cf0;
      margin-bottom: 5px;
    }

    .record-content {
      background: #f9f9f9;
      padding: 12px;
      border-radius: 4px;
      margin-bottom: 10px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    }

    .record-main-info {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin-bottom: 8px;

      .ivu-tag {
        margin-right: 10px;
      }
    }

    .record-info-item {
      margin-right: 15px;
      color: #515a6e;
      display: inline-flex;
      align-items: center;
      font-size: 13px;

      i {
        margin-right: 4px;
        color: #808695;
      }
    }

    .record-extra-info {
      border-top: 1px dashed #e8e8e8;
      padding-top: 8px;
      margin-top: 5px;
      color: #808695;
      font-size: 13px;

      p {
        margin-bottom: 4px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .record-remark {
      color: #808695;
      font-style: italic;
      display: flex;
      align-items: flex-start;

      i {
        margin-right: 5px;
        margin-top: 2px;
      }
    }
  }
}

.detail-card {
  margin-bottom: 20px;
}


.detail-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  .detail-item {
    padding: 10px;
    background: #f9f9f9;
    border-radius: 4px;
    border-left: 3px solid #2d8cf0;

    strong {
      display: flex;
      align-items: center;
      color: #17233d;
      margin-bottom: 8px;
      font-size: 14px;
      margin-right: 10px;

      i {
        margin-right: 5px;
      }
    }

    span {
      color: #515a6e;
      font-size: 15px;
    }
  }
}

.modal-footer {
  margin-top: 20px;

  .btn-group {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;

    .ivu-btn {
      margin: 0 10px;
    }
  }
}

.detail-content {
  padding: 0;

  .detail-header {
    margin-bottom: 20px;
    padding: 15px;
    background: #f8f8f9;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .asset-id-box {
      display: flex;
      align-items: center;

      .asset-id {
        font-size: 18px;
        font-weight: bold;
        margin-left: 10px;
        color: #17233d;
      }
    }

    .status-tag {
      font-size: 14px;
    }
  }

  .detail-card {
    margin-bottom: 20px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);

    ::v-deep .ivu-card-head {
      padding: 12px 16px;
      background: #f8f8f9;

      p {
        display: flex;
        align-items: center;

        i {
          margin-right: 8px;
        }
      }
    }

    ::v-deep .ivu-card-body {
      padding: 16px;
    }
  }

  .desc-section {
    margin-bottom: 16px;

    h4 {
      display: flex;
      align-items: center;
      color: #17233d;
      margin-bottom: 8px;
      font-size: 14px;
      font-weight: bold;

      i {
        margin-right: 5px;
      }
    }

    .desc-content {
      background: #f9f9f9;
      padding: 12px;
      border-radius: 4px;
      color: #515a6e;
      min-height: 80px;
      height:fit-content;
      white-space: pre-wrap;
      line-height: 1.6;
    }
  }

  .no-records {
    text-align: center;
    color: #808695;
    padding: 30px 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    i {
      margin-bottom: 10px;
      color: #c5c8ce;
    }
  }

  .records-list {
    max-height: 350px;
    overflow-y: auto;
    padding: 10px;

    .record-time {
      font-weight: bold;
      color: #2d8cf0;
      margin-bottom: 5px;
    }

    .record-content {
      background: #f9f9f9;
      padding: 12px;
      border-radius: 4px;
      margin-bottom: 10px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    }

    .record-main-info {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin-bottom: 8px;

      .ivu-tag {
        margin-right: 10px;
      }
    }

    .record-info-item {
      margin-right: 15px;
      color: #515a6e;
      display: inline-flex;
      align-items: center;
      font-size: 13px;

      i {
        margin-right: 4px;
        color: #808695;
      }
    }

    .record-extra-info {
      border-top: 1px dashed #e8e8e8;
      padding-top: 8px;
      margin-top: 5px;
      color: #808695;
      font-size: 13px;

      p {
        margin-bottom: 4px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .record-remark {
      color: #808695;
      font-style: italic;
      display: flex;
      align-items: flex-start;

      i {
        margin-right: 5px;
        margin-top: 2px;
      }
    }
  }
}

.type-config-modal {
  .modal-header {
    display: flex;
    align-items: center;
  }

  .modal-header span {
    font-size: 16px;
    font-weight: 500;
    margin-left: 10px;
    color: #2d8cf0;
  }

  .type-config-content {
    padding: 20px;
  }

  .type-form {
    margin-bottom: 20px;
    padding: 15px;
    background: #f8f8f9;
    border-radius: 4px;
  }

  .type-list {
  }
}

.search-input-bar {
  padding: 12px 16px;
  display: flex;
  align-items: center;
}
</style>
